<template>
  <v-autocomplete
    :items="years"
    item-value="id"
    item-text="name"
    v-model="yearSelected"
    label="Year"
    :rules="[requiredCheck()]"
    outlined
    :dense="dense != null ? dense : false"
    :hide-details="hideDetails != null ? hideDetails : false"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import { required } from '@/lib/formValidations'

export default {
  props: [
    'year',
    'isRequired',
    'dense',
    'hideDetails',
    'disabled'
  ],
  computed: {
    yearSelected: {
      get () {
        return this.year || new Date().getFullYear()
      },
      set (newValue) {
        this.$emit('yearChange', newValue)
      }
    },
    years () {
      let currentYear = new Date().getFullYear()
      let years = []
      for (let y = 2019; currentYear >= y; y++) {
        years.push({ name: y, id: y })
      }
      return years
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required('Client')
    }
  }
}
</script>
